<!-- eslint-disable -->
<template>
<div class="G_modal">
    <modal-header
      @event-close-child-modals="eventCloseChildModals"
      @event-close-modal="selfClose"
      :title="modalTitle">
    </modal-header>
    <hr>
  <div class="p2s3m4_help_text"></div>
  <div class="p2s3m4_grid_container">
    <div class="p2s3m4_name_label">Name</div>
    <div class="p2s3m4_name_field_div">
      <input class="p2s3m4_name_field" v-model="orgName" type="text" placeholder="Organization Name">
    </div>
    <div class="p2s3m4_description_label">Description</div>
    <div class="p2s3m4_name_description_div">
      <input class="p2s3m4_description_field" v-model="orgDescription" type="text"  placeholder="Organization Description (optional)">
    </div>
    <div class="p2s3m4_buttons">
      <button @click="createOrg" class="p2s3m4_create_org_button">Create Organization</button>
      <button @click="selfClose" class="p2s3m4_cancel_button">Cancel</button>
    </div>
  </div>
  </div>
</template>

<script>
/* eslint-disable */
import ModalHeader from "../p2ModalHeader";
import c22FullPathLabel from "../../Labels/c22FullPathLabel";
import { bi10ModalTemplate } from "../../../watchdog_includes/base_i10_UI_mixins";
import createOrganizationCall from "../../../watchdog_includes/legacy_calls/p2s1t27_CreateOrganization"
export default {
  name: "p2s3m4CreateRootOrganization",
  components: {
    ModalHeader,
    c22FullPathLabel,
  },
  data: function() {
    return {
      modalTitle:'Create Billing Organization',
      defaultModal:'default',
      orgName:null,
      orgDescription:null
    };
  },
  mixins: [bi10ModalTemplate],
  methods: {
      createOrg() {
          if (this.orgDescription === null) {
              this.orgDescription = ' ';
          }
          createOrganizationCall('root',this.orgName,this.orgDescription);
          this.selfClose();
      }
    
  }
};
</script>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s3accountSettings/p2s3m4CreateRootOrganization.vue